import React, { useContext, useRef, useState } from "react";
import { UserData } from "../../../Context/DataContext";
import styles from "./styles/Dashboard.module.css";
import { CSSTransition } from "react-transition-group";
import KeepAlive from "./KeepAlive";
import WelcomePopup from "./WelcomePopup";
import EditAsset from "../Edit Asset/EditAsset";
import AddAsset from "../Add Asset/AddAsset";
import Rect from "../Rect/Rect";
import { useEffect } from "react";
import {
  handleIssueActions,
  handleIssues,
  handleSharedIssues,
  handleTips,
} from "../../../Utils/handleIssues";
import { useNavigate } from "react-router-dom";
// onboarding popups
import {
  handleNextClick,
  handleBackClick,
  handleCloseClick,
} from "../../../Utils/onboardingButtons";
import { maxWidth } from "@mui/system";
import SelfRecoveryPopUp from "../Self Recovery/SelfRecovery";
import AddNotaryPopUp from "../AddNotaryPopup/AddNotaryPopup";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import ReferralLoginPopup from "./referralLoginPopup";
import config from "../../../config";
import tips_icon from "./styles/img/tips_icon.svg";
import attention_icon from "./styles/img/attention_icon.svg";
import ok_icon from "./styles/img/ok.svg";
import useWindowDimensions from "../../Footer/footer";
import { RightOutlined } from "@ant-design/icons";
import { useAuth } from "../../../Context/AuthContext";
import { PageHeading } from "../PartnerNav/PageHeading";
const base_url = config.base_url;
function Dashboard() {
  // onboarding popups
  const userData = UserData();
  const { width } = useWindowDimensions();
  const authData = useAuth();
  console.log(authData);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.Dashboard.Dashboard
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const [tipContent, setTipContent] = useState(
    websiteCurrentLang.content.User.Dashboard.Issues
  );
  const [issueContent, setIssueContent] = useState(
    websiteCurrentLang.content.User.Dashboard.ISSUES
  );
  const [readMoreButton, setReadMoreButton] = useState(false);
  const [showMoreText, setShowMoreText] = useState(false);
  const [gridColumn, setGridColumn] = useState(23);
  const [gridwidth, setGridwidth] = useState("260px");
  const [gridHeight, setGridHeight] = useState("unset");
  const [maxHeight, setMaxHeight] = useState("100px");
  const [height, setHeight] = useState(0);
  const [containerHeight, setContainerHeight] = useState("100%");
  const [ref1Height, setRef1Height] = useState("100%");
  // const [height2, setHeight2] = useState(0);
  const ref1 = useRef(null);
  const containerRef = useRef(null);
  // const ref2 = useRef(null);
  const [initialHeight, setInitialHeight] = useState();

  useEffect(() => {
    setContent(websiteCurrentLang.content.User.Dashboard.Dashboard);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    setTipContent(websiteCurrentLang.content.User.Dashboard.TIPS);
    setIssueContent(websiteCurrentLang.content.User.Dashboard.ISSUES);
  }, [websiteCurrentLang]);
  const isFirstLogin = userData.CustomerUser?.first_login;
  // const issues = [].concat(...userData?.UserData?.issues)
  // const [issues, setIssues] = useState(location?.state?.blink?[].concat([].concat(...handleIssues(userData?.UserData, userData?.BillingData, userData?.CustomerUser, issueContent))):[]);
  const [issues, setIssues] = useState([]);
  const [keepAlive, setKeepAlive] = useState(
    userData?.UserData?.inheritance_parameters.sent_notifications > 0 &&
      !userData?.isFreezed
  );
  const [modal, setModal] = useState(null);
  const navigate = useNavigate();
  const [visibleTips, setVisibleTips] = useState([]);
  const [displayedTip1, setDisplayedTip1] = useState(null);
  const [displayedTip2, setDisplayedTip2] = useState(null);
  const [noEnoughAttentionButShowTips, setNoEnoughAttentionButShowTips] =
    useState(false);
  const [tipLink, setTipLink] = useState(null);
  const [couponData, setCouponData] = useState(undefined);
  const issuesNavigate = {
    1: {
      url: ["/user/assetmanagement", "/user/beneficiaries"],
      text: [content.dashboardText1, content.dashboardText2],
    },
    2: {
      url: ["/user/assetmanagement"],
      text: [content.dashboardText3],
    },
    3: {
      url: ["/user/beneficiaries"],
      text: [content.dashboardText4],
    },
    4: {
      url: ["/user/trustees"],
      text: [content.dashboardText5],
    },
    5: {
      url: ["/user/plan"],
      text: [content.dashboardText6],
    },
    7: {
      url: ["/user/account", "hide"],
      text: [content?.dashboardText14, content?.dashboardText12],
    },
    8: {
      url: ["/user/account", "hide"],
      text: [content?.dashboardText15, content?.dashboardText12],
    },
    9: {
      url: ["/user/account", "hide"],
      text: [content?.dashboardText16, content?.dashboardText12],
    },
  };

  useEffect(() => {
    setRef1Height(ref1.current.scrollHeight);
  }, [issues]);

  useEffect(() => {
    // if(location?.state?.blink) return
    console.log("Rendering issues, should not");
    /*
      In the partner's view of a customer, only the four mechanism issues are
      computed -- and from the shared payload, so none of them can name an asset
      or a beneficiary the customer did not share.

      handleIssues cannot be used here at all: its billing and customer
      arguments are, inside this view, still the PARTNER's own. It would show
      them their own subscription warnings under a customer's name.
    */
    var new_issues = userData.partnerReadOnly
      ? handleSharedIssues(userData.UserData, issueContent)
      : handleIssues(
          userData.UserData,
          userData.BillingData,
          userData.CustomerUser,
          issueContent
        );
    console.log("Calculating issues");
    console.log(issueContent);
    setIssues([].concat([].concat(...new_issues)));

    // userData?.setBlink(false)
  }, [userData?.UserData?.issues, issueContent]);

  useEffect(() => {
    setVisibleTips(handleTips(userData?.CustomerUser, userData?.UserData));
    setActiveIndex(0);
  }, []);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === ref1.current) {
          setHeight(entry.contentRect.height + 32);
        }
      }
    });

    observer.observe(ref1.current);

    return () => {
      observer.disconnect();
    };
  }, [ref1, issues, containerRef, showMoreText]);

  function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value?.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function setCookie(name, value) {
    document.cookie = `${name}=${value}; path=/`;
  }
  // const [blink, setBlink] = useState(userData?.blink)
  const [hiddenTips, setHiddenTips] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = (noClose) => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % visibleTips.length);
    if (noClose) return;
    setShowMoreText(false);
    setNoEnoughAttentionButShowTips(false);
  };

  const handlePrev = (noClose) => {
    setActiveIndex(
      (prevIndex) => (prevIndex - 1 + visibleTips.length) % visibleTips.length
    );
    if (noClose) return;
    setShowMoreText(false);
    setNoEnoughAttentionButShowTips(false);
  };
  useEffect(() => {
    const hiddenTipsFromCookies = JSON.parse(getCookie("hidden_tips") || "{}");
    setHiddenTips(hiddenTipsFromCookies);
  }, []);
  useEffect(() => {
    const referral_code = userData?.CustomerUser?.register_code;

    if (!referral_code || referral_code === "undefined") return;

    fetch(base_url + "newuser/referral/validate", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `coupon=${referral_code}&dollar_quantity=1`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status !== 200) throw new Error("Not vali coupon");
        else return res.json();
      })
      .then((res) => {
        setCouponData(res);
      })
      .catch(() => {});
  }, []);

  const hideCurrentTip = (event, tip) => {
    userData.setCustomerUser({
      ...userData?.CustomerUser,
      hided_tips: [...userData?.CustomerUser?.hided_tips, tip?.id],
    });
    setVisibleTips(visibleTips.filter((e) => e?.id !== tip?.id));
  };

  useEffect(() => {
    setCookie("hidden_tips", JSON.stringify(hiddenTips));
  }, [hiddenTips]);
  const isPrevDisabled = activeIndex === 0;
  const isNextDisabled = activeIndex === visibleTips.length - 1;
  let issuesNumber = issues?.filter((e) => e.type !== 4)?.length;
  const visibleTipsNumber = visibleTips.length;

  if (userData.CustomerUser.user_type.toLowerCase() === "partner") {
    issuesNumber = issues?.filter((e) => e.type !== 4 && e.type !== 5)?.length;
  }
  useEffect(() => {
    let initialNumber;
    let gap;

    issuesNumber === 0 ? (gap = 28) : (gap = issuesNumber * 28);
    issuesNumber === 0
      ? (initialNumber = 2)
      : (initialNumber = issuesNumber + 1);
    setInitialHeight(`${initialNumber * 34 + 32 + gap}px`);
  }, [issuesNumber]);

  useEffect(() => {
    if (width < 1300) {
      setShowMoreText(false);
      setReadMoreButton(true);
      setNoEnoughAttentionButShowTips(true);
      setMaxHeight("100%");
    }
  }, [width]);
  useEffect(() => {
    setShowMoreText(false);
    setReadMoreButton(true);
    setNoEnoughAttentionButShowTips(false);
  }, [issuesNumber]);
  useEffect(() => {
    if (!tipContent) return;
    let tip1Length;
    let tip2Length;
    let tipLinkLength;
    let fullTipLength = tipContent[visibleTips[activeIndex]?.id]?.length;

    if (!showMoreText) {
      setGridwidth("100%");
      setGridHeight("100%");
      issuesNumber <= 2 ? setMaxHeight("0px") : setMaxHeight("unset");
      width < 1300 && setMaxHeight("unset");
    } else if (fullTipLength < 150) {
      setGridHeight(height > 300 ? height : "300px");

      issuesNumber <= 4 && setRef1Height("300px");
      issuesNumber > 4 && setRef1Height("100%");
      setMaxHeight("100px");
      setGridColumn("24");
      setGridwidth("130%");
    } else if (fullTipLength >= 150 && fullTipLength < 250) {
      setGridHeight(
        height > 300 ? height : issuesNumber <= 4 ? "300px" : "350px"
      );
      issuesNumber <= 4 && setRef1Height("300px");
      issuesNumber > 4 && setRef1Height("100%");
      setGridColumn("22");
      setGridwidth("180%");

      setMaxHeight("120px");
    } else if (fullTipLength >= 250 && fullTipLength < 300) {
      setGridHeight(height > 350 ? height : "350px");
      setMaxHeight("150px");
      issuesNumber <= 4 && setRef1Height("350px");
      issuesNumber > 4 && setRef1Height("100%");
      setGridColumn("21");
      setGridwidth("200%");
    } else if (fullTipLength >= 300 && fullTipLength < 400) {
      setGridHeight(height > 350 ? height : "350px");
      setMaxHeight("150px");
      issuesNumber <= 4 && setRef1Height("350px");
      issuesNumber > 4 && setRef1Height("100%");
      setGridColumn("19");
      setGridwidth("220%");
    } else if (fullTipLength >= 400 && fullTipLength < 500) {
      setGridColumn("18");
      setGridwidth("240%");
      setGridHeight(height > 350 ? height : "350px");
      setMaxHeight("200px");
      issuesNumber <= 4 && setRef1Height("350px");
      issuesNumber > 4 && setRef1Height("100%");
    } else if (fullTipLength >= 500 && fullTipLength < 600) {
      setGridHeight(height > 380 ? height : "380px");
      issuesNumber <= 4 && setRef1Height("380px");
      issuesNumber > 4 && setRef1Height("100%");
      setGridColumn("17");
      setGridwidth("260%");
      setMaxHeight("200px");
    } else if (fullTipLength >= 600 && fullTipLength < 700) {
      setGridColumn("16");
      setGridwidth("280%");
      setGridHeight(height > 400 ? height : "400px");
      setMaxHeight("200px");
      issuesNumber <= 4 && setRef1Height("400px");
      issuesNumber > 4 && setRef1Height("100%");
    } else if (fullTipLength >= 700 && fullTipLength < 800) {
      setGridColumn("15");
      setGridwidth("290%");
      setGridHeight(height > 400 ? height : "400px");
      setMaxHeight("220px");
      issuesNumber <= 4 && setRef1Height("400px");
      issuesNumber > 4 && setRef1Height("100%");
    } else if (fullTipLength >= 800 && fullTipLength < 900) {
      setGridColumn("14");
      setGridwidth("300%");
      setGridHeight(height > 420 ? height : "420px");
      setMaxHeight("240px");
      issuesNumber <= 4 && setRef1Height("420px");
      issuesNumber > 4 && setRef1Height("100%");
    } else if (fullTipLength >= 900 && fullTipLength < 1000) {
      setGridColumn("13");
      setGridwidth("320%");
      setGridHeight(height > 420 ? height : "420px");
      setMaxHeight("240px");
      issuesNumber <= 4 && setRef1Height("420px");
      issuesNumber > 4 && setRef1Height("100%");
    } else if (fullTipLength >= 1000 && fullTipLength < 1100) {
      setGridColumn("11");
      setGridwidth("340%");
      setGridHeight(height > 450 ? height : "450px");
      setMaxHeight("400px");
      issuesNumber <= 4 && setRef1Height("450px");
      issuesNumber > 4 && setRef1Height("100%");
    } else if (fullTipLength >= 1000 && fullTipLength < 1200) {
      setGridColumn("10");
      setGridwidth("340%");
      setGridHeight(height > 450 ? height : "450px");
      setMaxHeight("400px");
      issuesNumber <= 4 && setRef1Height("450px");
      issuesNumber > 4 && setRef1Height("100%");
    } else if (fullTipLength >= 1200 && fullTipLength < 1300) {
      setGridColumn("9");
      setGridwidth("370%");
      setGridHeight(height > 450 ? height : "450px");
      setMaxHeight("400px");
      issuesNumber <= 4 && setRef1Height("450px");
      issuesNumber > 4 && setRef1Height("100%");
    } else {
      setGridColumn("5");
      setGridwidth("400%");
      setGridHeight("100%");
      setMaxHeight("max-content");
      setRef1Height("100%");
      setRef1Height("100%");
    }

    if (tipContent[visibleTips[activeIndex]?.id]?.split("@").length < 3) {
      // in mobile version
      if (width < 1299) {
        setDisplayedTip1(
          tipContent[visibleTips[activeIndex]?.id]?.split("@")[0]
        );
        setTipLink(
          `${tipContent[visibleTips[activeIndex]?.id]?.split("@")[1]}`
        );
        setDisplayedTip2(
          tipContent[visibleTips[activeIndex]?.id]?.split("@")[2]
        );
      }
      setNoEnoughAttentionButShowTips(false);
      setDisplayedTip1(tipContent[visibleTips[activeIndex]?.id]);
      tip1Length = tipContent[visibleTips[activeIndex]?.id].length;

      setDisplayedTip2(undefined);
      setTipLink(undefined);
    } else {
      if (width < 1299) {
        setDisplayedTip1(
          tipContent[visibleTips[activeIndex]?.id]?.split("@")[0]
        );
        setTipLink(
          `${tipContent[visibleTips[activeIndex]?.id]?.split("@")[1]}`
        );
        setDisplayedTip2(
          tipContent[visibleTips[activeIndex]?.id]?.split("@")[2]
        );
        setNoEnoughAttentionButShowTips(false);
        return;
      }

      setDisplayedTip1(tipContent[visibleTips[activeIndex]?.id]?.split("@")[0]);
      setTipLink(`${tipContent[visibleTips[activeIndex]?.id]?.split("@")[1]}`);
      setDisplayedTip2(tipContent[visibleTips[activeIndex]?.id]?.split("@")[2]);
      tip1Length =
        tipContent[visibleTips[activeIndex]?.id]?.split("@")[0].length;
      tip2Length =
        tipContent[visibleTips[activeIndex]?.id]?.split("@")[2].length;
      tipLinkLength =
        tipContent[visibleTips[activeIndex]?.id]?.split("@")[1].length;
    }
    const setTipsLenghtes = (requiredLength) => {
      if (showMoreText || width < 1299) {
        return false;
      }
      if (tip1Length >= requiredLength) {
        setDisplayedTip1(
          tipContent[visibleTips[activeIndex]?.id]
            ?.split("@")[0]
            .slice(0, requiredLength)
        );
        setTipLink(undefined);
        setDisplayedTip2(undefined);

        return true;
      } else if (tip1Length + tipLinkLength >= requiredLength) {
        setTipLink(
          tipContent[visibleTips[activeIndex]?.id]
            ?.split("@")[1]
            .slice(0, requiredLength - tip1Length)
        );

        setDisplayedTip2(undefined);

        return true;
      } else if (tip1Length + tipLinkLength + tip2Length >= requiredLength) {
        setDisplayedTip2(
          tipContent[visibleTips[activeIndex]?.id]
            ?.split("@")[2]
            .slice(0, requiredLength - tip1Length - tipLinkLength - tip2Length)
        );

        return true;
      }
      setReadMoreButton(false);
      return false;
    };

    if (issuesNumber === 3) {
      const isCut = setTipsLenghtes(40);
      if (isCut) setReadMoreButton(true);
    } else if (issuesNumber === 4) {
      const isCut = setTipsLenghtes(90);
      if (isCut) setReadMoreButton(true);
    } else if (issuesNumber === 5) {
      const isCut = setTipsLenghtes(130);
      if (isCut) setReadMoreButton(true);
    } else if (issuesNumber === 6) {
      const isCut = setTipsLenghtes(150);
      if (isCut) setReadMoreButton(true);
    } else if (issuesNumber === 7) {
      const isCut = setTipsLenghtes(200);
      if (isCut) setReadMoreButton(true);
    } else if (issuesNumber === 8) {
      const isCut = setTipsLenghtes(250);
      if (isCut) setReadMoreButton(true);
    } else if (issuesNumber === 9) {
      const isCut = setTipsLenghtes(300);
      if (isCut) setReadMoreButton(true);
    } else if (issuesNumber === 10) {
      const isCut = setTipsLenghtes(350);
      if (isCut) setReadMoreButton(true);
    } else if (issuesNumber === 11) {
      const isCut = setTipsLenghtes(450);
      if (isCut) setReadMoreButton(true);
    } else if (issuesNumber === 12) {
      const isCut = setTipsLenghtes(600);
      if (isCut) setReadMoreButton(true);
    } else {
      const isCut = setTipsLenghtes(1000);
      if (isCut) setReadMoreButton(true);
    }
  }, [
    tipContent,
    activeIndex,
    showMoreText,
    width,
    visibleTipsNumber,
    issuesNumber,
  ]);

  return (
    <div
      style={{
        // marginBottom: "60px",
        // height: containerHeight,
        display: "flex",
        flexDirection: "column",
        // transition: "all 0.5s",
      }}
    >
      <PageHeading
        as="div"
        className={styles.main_title}
        title={content.dashboardTitle1}
      />
      <div
        ref={containerRef}
        className={styles.main}
        style={
          showMoreText
            ? {
                height: width < 1300 ? "100%" : ref1Height,
                // position: "relative",
                // marginBottom: "60px",
                // paddingBottom: "50px",
                // borderBottom: "1px solid red",
              }
            : {
                height:
                  width < 1300
                    ? "100%"
                    : issuesNumber <= 4
                    ? initialHeight
                    : "100%",
                // paddingBottom: "50px",
                // borderBottom: "1px solid red",
              }
        }
      >
        <div
          style={
            showMoreText
              ? {
                  height: ref1Height,
                  width: "100%",
                  marginRight: "15px",
                  gridRow: "1/2",
                  // gridColumn: "1/26",
                  gridColumn: "7/32",
                }
              : {
                  width: "100%",
                  marginRight: "15px",
                  gridRow: "1/2",
                  // gridColumn: "1/26",
                  gridColumn: "7/32",
                }
          }
          className={`${
            issues?.length !== 0 ? styles.main_left : styles.main_left_no_issues
          }
              ${
                userData?.blink &&
                issues?.filter((e) => e.type == 1)?.length === 0
                  ? styles.blink
                  : ""
              }`}
        >
          <div
            className={styles.issues}
            // style={
            //   height > height2
            //     ? { height: `${height}px` }
            //     : { height: `${height2}px` }
            // }
            ref={ref1}
          >
            <div className={styles.attentionBox}>
              <img src={attention_icon} alt="attention" />
              <span>{content.dashboardText7}</span>
            </div>

            {isFirstLogin && (
              <div className="hint_popup hint_popup_issues" id="2">
                <div className="hint_text">{content.dashboardText8}</div>
                <div className="hint_actions">
                  <button
                    onClick={() => handleBackClick()}
                    className="hint_btn hint_btn--back"
                  >
                    {dublicatedcontent.dublicatedText71}
                  </button>
                  <div className="hint_counter">3/6</div>
                  <button
                    onClick={() => handleNextClick()}
                    className="hint_btn hint_btn--next"
                  >
                    {dublicatedcontent.dublicatedText72}
                  </button>
                </div>
                <button
                  onClick={(e) => {
                    handleCloseClick(userData);
                  }}
                  className="close_hint_btn"
                ></button>
              </div>
            )}

            {issuesNumber !== 0 ? (
              userData.CustomerUser.user_type.toLowerCase() === "partner" ? (
                issues
                  ?.filter((e) => {
                    // console.log(e.type);
                    return e.type !== 4 && e.type !== 5;
                  })
                  ?.map((issue, index) => {
                    return (
                      <div
                        key={index}
                        className={`${styles.issue_type} ${
                          userData?.blink && issue.type == 1 ? styles.blink : ""
                        }`}
                      >
                        <div className={styles.issue_item}>
                          <div className={styles.issue_logo} />
                          <div className={styles.issue_text}>{issue.text}</div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "0px",
                            width: maxWidth,
                            justifyContent: "center",
                          }}
                        >
                          {issuesNavigate[issue.type]?.text.map(
                            (text, index) => {
                              return (
                                <div
                                  key={index}
                                  className={
                                    index > 0
                                      ? styles.blue_text_2
                                      : styles.blue_text
                                  }
                                  onClick={() => {
                                    const url =
                                      issuesNavigate[issue.type].url[index];
                                    return handleIssueActions(
                                      userData,
                                      setModal,
                                      navigate,
                                      issues?.filter((e) => e.type !== 4),
                                      issue,
                                      url,
                                      setIssues
                                    );
                                  }}
                                >
                                  {text}
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    );
                  })
              ) : (
                issues
                  ?.filter((e) => e.type !== 4)
                  ?.map((issue, index) => {
                    return (
                      <div
                        key={index}
                        className={`${styles.issue_type} ${
                          userData?.blink && issue.type == 1 ? styles.blink : ""
                        }`}
                      >
                        <div className={styles.issue_item}>
                          <div className={styles.issue_logo} />
                          <div className={styles.issue_text}>{issue.text}</div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "0px",
                            width: maxWidth,
                            justifyContent: "center",
                          }}
                        >
                          {issuesNavigate[issue.type]?.text.map(
                            (text, index) => {
                              return (
                                <div
                                  key={index}
                                  className={
                                    index > 0
                                      ? styles.blue_text_2
                                      : styles.blue_text
                                  }
                                  onClick={() => {
                                    const url =
                                      issuesNavigate[issue.type].url[index];
                                    return handleIssueActions(
                                      userData,
                                      setModal,
                                      navigate,
                                      issues?.filter((e) => e.type !== 4),
                                      issue,
                                      url,
                                      setIssues
                                    );
                                  }}
                                >
                                  {text}
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    );
                  })
              )
            ) : (
              <div className={styles.issue_text_container}>
                <img
                  src={ok_icon}
                  alt="ok
                "
                />
                <div className={styles.issue_text}>
                  {content.dashboardText11}
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          className={`${styles.main_right} ${styles.main_right_grid} `}
          style={
            showMoreText
              ? {
                  // gridColumnStart: showMoreText ? gridColumn : "26",
                  width: gridwidth,
                  flexDirection: "row",
                  height: gridHeight,
                }
              : { width: "100%" }
          }
        >
          {showMoreText && width > 1299 && (
            <div
              style={{
                marginRight: "15px",
                borderRight: "1px solid #DCDCDC",
                width: "50px",

                display: "flex",
                alignItems: "center",
                paddingRight: "10px",
              }}
            >
              <RightOutlined
                onClick={() => {
                  setShowMoreText(false);
                  setNoEnoughAttentionButShowTips(false);
                }}
                style={{ cursor: "pointer", color: "rgb(220, 220, 220)" }}
              />
            </div>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "5px",
              }}
            >
              <div
                style={{
                  width: "100%",
                }}
              >
                <div
                  className={styles.security_tip}
                  style={
                    issuesNumber <= 1 && visibleTipsNumber > 0
                      ? {
                          marginBottom: "15px",
                        }
                      : issuesNumber <= 2 && visibleTipsNumber > 0
                      ? {
                          marginBottom: "29px",
                        }
                      : {}
                  }
                >
                  <img
                    src={tips_icon}
                    alt="tips"
                    style={{
                      height: "100%",
                    }}
                  />
                  <span>{dublicatedcontent?.tips}</span>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    {/* Show the active tip */}

                    {!noEnoughAttentionButShowTips &&
                      issuesNumber <= 2 &&
                      visibleTipsNumber > 0 &&
                      width > 1299 && (
                        <>
                          <div className={styles.notEnoughtAttentionBox}>
                            <span>
                              {dublicatedcontent?.we_got_x_tips_for_you?.replace(
                                "AMOUNT",
                                visibleTipsNumber
                              )}
                            </span>
                            <span
                              onClick={(e) => {
                                setShowMoreText(true);
                                setNoEnoughAttentionButShowTips(true);
                              }}
                              style={{
                                color: "var(--color_blue)",
                                cursor: "pointer",
                                fontWeight: "500",
                              }}
                            >
                              {dublicatedcontent?.click_here_to_see_them}
                            </span>
                          </div>
                        </>
                      )}
                    {((visibleTips.length > 0 && issuesNumber > 2) ||
                      (visibleTips.length > 0 &&
                        issuesNumber >= 0 &&
                        width < 1300)) && (
                      <div>
                        <div className={styles.issue_item}>
                          <div className={styles.warning_logo} />
                          {visibleTips[activeIndex]?.id ? (
                            <CSSTransition
                              timeout={500}
                              classNames={"fade"}
                              in={readMoreButton}
                            >
                              <div
                                className={styles.warning_text}
                                style={{
                                  maxHeight: maxHeight,
                                  overflow: "hidden",
                                }}
                              >
                                <span>
                                  {displayedTip1}
                                  <a
                                    rel="noreferrer"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "400",
                                    }}
                                    className={styles.blue_text}
                                    onClick={() => {
                                      if (visibleTips[activeIndex].navigate)
                                        return navigate(
                                          visibleTips[activeIndex].navigate,
                                          { replace: true }
                                        );
                                      else if (
                                        visibleTips[activeIndex]?.openModal ===
                                        "SelfRecoveryPopUp"
                                      )
                                        setModal(
                                          <SelfRecoveryPopUp
                                            onClose={() => setModal()}
                                          />
                                        );
                                      else if (
                                        visibleTips[activeIndex]?.openModal ===
                                        "AddNotaryPopUp"
                                      )
                                        setModal(
                                          <AddNotaryPopUp
                                            onClose={() => setModal()}
                                          />
                                        );
                                      else if (
                                        visibleTips[activeIndex]?.openModal ===
                                        "AddAsset"
                                      )
                                        setModal(
                                          <AddAsset
                                            onClose={() => setModal()}
                                            asset_type="Your Will"
                                          />
                                        );
                                      else return;
                                    }}
                                    target={"_blank"}
                                    href={visibleTips[activeIndex].url}
                                  >
                                    {tipLink}
                                  </a>
                                  {displayedTip2}
                                  {readMoreButton && width > 1299 && (
                                    <span
                                      onClick={(e) => {
                                        setShowMoreText(true);
                                        setReadMoreButton(false);
                                      }}
                                      style={{
                                        color: "var(--color_blue)",
                                        margin: "0 ",
                                        height: "max-content",
                                        textAlign: "center",
                                        fontSize: "14px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "16px",
                                          fontWeight: "700",
                                        }}
                                      >
                                        ...
                                      </span>
                                      {dublicatedcontent.dublicatedText68}
                                    </span>
                                  )}
                                </span>
                              </div>
                            </CSSTransition>
                          ) : (
                            <div className={styles.warning_text}>
                              {visibleTips[activeIndex]}
                            </div>
                          )}
                        </div>
                        <div
                          className={styles.tip_actions}
                          style={
                            width > 1299
                              ? {
                                  position: "absolute",
                                  bottom: "10px",
                                  width: "100%",
                                }
                              : {}
                          }
                        >
                          <span
                            className={styles.hide_tip}
                            onClick={(event) =>
                              hideCurrentTip(event, visibleTips[activeIndex])
                            }
                          >
                            {content.dashboardText12}
                          </span>

                          {Number(visibleTips[activeIndex]?.type) === 4 && (
                            <span
                              className={styles.blue_text}
                              onClick={() => {
                                setModal(
                                  <EditAsset
                                    onClose={() => setModal(null)}
                                    toEdit={
                                      userData?.UserData?.assets?.filter(
                                        (e) =>
                                          e.asset_id ===
                                          visibleTips[activeIndex]?.id
                                      )[0]
                                    }
                                    openAssets={true}
                                  />
                                );
                              }}
                            >
                              {issuesNavigate[4].text}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {visibleTips.length > 0 && noEnoughAttentionButShowTips && (
                      <div>
                        <div className={styles.issue_item}>
                          <div className={styles.warning_logo} />
                          {visibleTips[activeIndex]?.id ? (
                            <div
                              className={styles.warning_text}
                              style={{
                                maxHeight: maxHeight,
                                overflow: "hidden",
                              }}
                            >
                              <span>
                                {displayedTip1}
                                <a
                                  rel="noreferrer"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                  className={styles.blue_text}
                                  onClick={() => {
                                    if (visibleTips[activeIndex].navigate)
                                      return navigate(
                                        visibleTips[activeIndex].navigate,
                                        { replace: true }
                                      );
                                    else if (
                                      visibleTips[activeIndex]?.openModal ===
                                      "SelfRecoveryPopUp"
                                    )
                                      setModal(
                                        <SelfRecoveryPopUp
                                          onClose={() => setModal()}
                                        />
                                      );
                                    else if (
                                      visibleTips[activeIndex]?.openModal ===
                                      "AddNotaryPopUp"
                                    )
                                      setModal(
                                        <AddNotaryPopUp
                                          onClose={() => setModal()}
                                        />
                                      );
                                    else if (
                                      visibleTips[activeIndex]?.openModal ===
                                      "AddAsset"
                                    )
                                      setModal(
                                        <AddAsset
                                          onClose={() => setModal()}
                                          asset_type="Your Will"
                                        />
                                      );
                                    else return;
                                  }}
                                  target={"_blank"}
                                  href={visibleTips[activeIndex].url}
                                >
                                  {tipLink}
                                </a>
                                {displayedTip2}
                                {readMoreButton && width > 1299 && (
                                  <span
                                    onClick={(e) => {
                                      setShowMoreText(true);
                                      setReadMoreButton(false);
                                    }}
                                    style={{
                                      color: "var(--color_blue)",
                                      margin: "0 ",
                                      height: "max-content",
                                      textAlign: "center",
                                      fontSize: "14px",

                                      cursor: "pointer",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      ...
                                    </span>{" "}
                                    {dublicatedcontent.dublicatedText68}
                                  </span>
                                )}
                              </span>
                            </div>
                          ) : (
                            <div className={styles.warning_text}>
                              {visibleTips[activeIndex]}
                            </div>
                          )}
                        </div>
                        <div
                          className={styles.tip_actions}
                          style={
                            width > 1299
                              ? {
                                  position: "absolute",
                                  bottom: "10px",
                                  width: "100%",
                                }
                              : {}
                          }
                        >
                          <span
                            className={styles.hide_tip}
                            onClick={(event) =>
                              hideCurrentTip(event, visibleTips[activeIndex])
                            }
                          >
                            {content.dashboardText12}
                          </span>

                          {Number(visibleTips[activeIndex]?.type) === 4 && (
                            <span
                              className={styles.blue_text}
                              onClick={() => {
                                setModal(
                                  <EditAsset
                                    onClose={() => setModal(null)}
                                    toEdit={
                                      userData?.UserData?.assets?.filter(
                                        (e) =>
                                          e.asset_id ===
                                          visibleTips[activeIndex]?.id
                                      )[0]
                                    }
                                    openAssets={true}
                                  />
                                );
                              }}
                            >
                              {issuesNavigate[4].text}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {visibleTips.length === 0 && (
                      <div className={styles.issue_text}>
                        {content.dashboardText13}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/*Tip Buttons */}
            {visibleTips.length > 1 && issuesNumber > 2 && (
              <>
                <div
                  className={styles.buttons_div}
                  style={
                    width > 1299
                      ? {
                          position: "absolute",
                          bottom: "0",
                          width: "100%",
                        }
                      : {
                          margin: " auto 0 0 0",
                        }
                  }
                >
                  {/* Previous button */}
                  <button
                    className={styles.button}
                    onClick={handlePrev}
                    disabled={isPrevDisabled}
                  >
                    <div className={styles.left_icon} />
                  </button>
                  {/* Next button */}
                  <button
                    className={styles.button}
                    onClick={handleNext}
                    disabled={isNextDisabled}
                  >
                    <div className={styles.right_icon} />
                  </button>
                </div>

                <div
                  className={styles.bullets}
                  style={{
                    bottom: "10px",
                  }}
                >
                  {/* Bullets */}
                  {visibleTips.map((_, index) => (
                    <span
                      key={index}
                      className={styles.bullet}
                      style={{
                        background:
                          index === activeIndex
                            ? "#0091EA"
                            : "rgba(234, 236, 240, 1)",
                      }}
                      onClick={() => setActiveIndex(index)}
                    ></span>
                  ))}
                </div>
              </>
            )}
            {(noEnoughAttentionButShowTips ||
              (issuesNumber <= 2 && width < 1300)) && (
              <>
                <div
                  className={styles.buttons_div}
                  style={
                    width > 1299
                      ? {
                          position: "absolute",
                          bottom: "0",
                          width: "100%",
                        }
                      : {
                          margin: " auto 0 0 0",
                        }
                  }
                >
                  {/* Previous button */}
                  <button
                    className={styles.button}
                    onClick={() => {
                      handlePrev(true);
                    }}
                    disabled={isPrevDisabled}
                  >
                    <div className={styles.left_icon} />
                  </button>
                  {/* Next button */}
                  <button
                    className={styles.button}
                    onClick={() => {
                      handleNext(true);
                    }}
                    disabled={isNextDisabled}
                  >
                    <div className={styles.right_icon} />
                  </button>
                </div>

                <div className={styles.bullets}>
                  {/* Bullets */}
                  {visibleTips.map((_, index) => (
                    <span
                      key={index}
                      className={styles.bullet}
                      style={{
                        background:
                          index === activeIndex
                            ? "#0091EA"
                            : "rgba(234, 236, 240, 1)",
                      }}
                      onClick={() => setActiveIndex(index)}
                    ></span>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Xabier, please add here &&if the referral code is not undefined , and also pass the code value and name to the referralLoginPopup. you will get this info from newuser/referral/validate */}

      {(localStorage.getItem("showReferralPopup") === "true" ||
        localStorage.getItem("showReferralPopup") === undefined) &&
        userData.BillingData.plan?.toLowerCase() === "free" &&
        userData.CustomerUser.register_code &&
        userData.CustomerUser.register_code !== undefined &&
        userData.CustomerUser.register_code !== "undefined" && (
          <ReferralLoginPopup couponData={couponData}></ReferralLoginPopup>
        )}
      {isFirstLogin &&
        userData.CustomerUser.show_welcome_popup === true &&
        (!userData.CustomerUser.register_code ||
          userData.CustomerUser.register_code === "undefined" ||
          userData.BillingData.plan?.toLowerCase() === "subscribed") &&
        userData.CustomerUser.user_type.toLowerCase() !== "partner" && (
          <WelcomePopup
            onClose={() => {
              userData.setCustomerUser({
                ...userData.CustomerUser,
                show_welcome_popup: false,
              });
            }}
            code={userData.BillingData.plan?.toLowerCase() === "subscribed"}
          ></WelcomePopup>
        )}

      {keepAlive && (
        <div style={{ position: "absolute", zIndex: "5" }}>
          <KeepAlive
            confirm_button={dublicatedcontent?.dublicatedText260}
            title={dublicatedcontent?.dublicatedText258}
            text={dublicatedcontent?.dublicatedText259}
            onClose={() => setKeepAlive(false)}
          />
        </div>
      )}

      {<div style={{ position: "absolute", zIndex: "6" }}>{modal}</div>}

      <Rect specialMargin={width < 1200 ? true : false} />
    </div>
  );
}

export default Dashboard;
